// import HTMX
import htmx from "htmx.org";

// import the CSP Alpine.js version
import Alpine from "@alpinejs/csp";
import Autosize from "@marcreichel/alpine-autosize";
import Clipboard from "@ryangjchandler/alpine-clipboard";

// import the Alpine custom components we're using
import AlpineComponents from "./alpine-component-loader";

mrp.log("Initialize HTMX");

// Attach HTMX reference
window.htmx = htmx;

// Extension to update HEAD content (only used for title in MRP)
require("htmx-ext-head-support/head-support");

// Extension to declaratively set focus on an element after swap
require("./htmx-ext-focus-selector.js");

// Hook up the HTMX request configuration handler
document.addEventListener("htmx:configRequest", function (evt) {
  // Get the antiforgery token from the RequestVerificationToken cookie
  // and add the request header so we're not dependent on hidden fields in forms
  const value = `; ${document.cookie}`;
  const parts = value.split("; RequestVerificationToken=");
  if (parts.length !== 2) return;
  evt.detail.headers["RequestVerificationToken"] = parts
    .pop()
    .split(";")
    .shift();
});

// Hook up the HTMX response error handler
document.addEventListener("htmx:responseError", function (evt) {
  // On error response from htmx, navigate to the endpoint specified in the response text
  let code = evt?.detail?.xhr?.status;
  let response = evt?.detail?.xhr?.responseText;
  if (response !== undefined && response !== null && response !== "") {
    mrp.log(response);
  }
  window.location.assign(`/error/${code}`);
});

mrp.log("Initialize Alpine");

// Attach Alpine reference
window.Alpine = Alpine;

// load alpine components
AlpineComponents.load();

// Add Alpine plugins and start
Alpine.plugin(Autosize);
Alpine.plugin(Clipboard);
Alpine.start();
